import BaseSelect, { Async as BaseAsync } from 'react-select'
import { Creatable as BaseCreatable } from 'react-select'
import Tooltip from './tooltip'
import { I18n } from '../services/i18n'

const BASE_SELECT_PROPS = props => ({
  noResultsText: I18n.t('ui.select.no_results'),
  placeholder: I18n.t('ui.select.placeholder'),
  searchPromptText: I18n.t('ui.select.search_prompt'),
  instanceId: props.name ? `input-${props.name}` : undefined
})

const BASE_DROPDOWN_PROPS = props => ({
  ...BASE_SELECT_PROPS(props),
  clearable: false,
  deleteRemoves: false,
  simpleValue: true
})

const BASE_ASYNC_PROPS = props => ({
  ...BASE_SELECT_PROPS(props),
  loadingPlaceholder: I18n.t('ui.select.loading_placeholder')
})

const BASE_CREATABLE_PROPS = props => ({
  ...BASE_SELECT_PROPS(props),
  promptTextCreator: label => I18n.t('ui.select.create_prompt', { label })
})

export const Select = props => (<BaseSelect {...BASE_SELECT_PROPS(props)} {...props} />);
export const Async = props => (<BaseAsync {...BASE_ASYNC_PROPS(props)} {...props} />);
export const Dropdown = props => (<BaseSelect {...BASE_DROPDOWN_PROPS(props)} {...props} />);
export const Creatable = props => (<BaseCreatable {...BASE_CREATABLE_PROPS(props)} {...props} />);
export class LocaleDropdown extends React.PureComponent {
  constructor() {
    super();
    this.options = I18n.config.list.map(value => ({ value, label: I18n.t(`ui.locales.${value}`) }));
  }

  render() {
    return <Dropdown value={this.props.value} options={this.options} onChange={this.props.onChange} />
  }
}

export class Multi extends React.PureComponent {
  constructor() {
    super();
    this.onChange = this.onChange.bind(this);
    this.onAddAll = this.onAddAll.bind(this);
  }

  onChange(list) {
    this.props.onChange(list.map(opt => opt.value));
  }

  onAddAll() {
    this.onChange(this.props.options);
  }

  render() {
    let { onChange, ...props } = this.props;
    return (
      <div className="input-group">
        <span className="input-group-addon">
          <Tooltip value="form.add_all" icon="plus" onClick={this.onAddAll} />
        </span>
        <BaseSelect multi onChange={this.onChange} {...props} />
      </div>
    );
  }
}
